import sessionStore from 'services/session_store';

const cookieName = 'authorization_token';
const adminCookieName = 'admin_authorization_token';

export const setAuthorizationToken = (authorizationToken) => {
  sessionStore.set(cookieName, authorizationToken);
};

export const getAuthorizationToken = () => {
  return sessionStore.get(cookieName);
};

export const deleteAuthorizationToken = () => {
  return sessionStore.delete(cookieName);
};

export const setAdminAuthorizationToken = (authorizationToken) => {
  sessionStore.set(adminCookieName, authorizationToken);
};

export const getAdminAuthorizationToken = () => {
  return sessionStore.get(adminCookieName);
};

export const deleteAdminAuthorizationToken = () => {
  return sessionStore.delete(adminCookieName);
};

export const getAuthorizationHeader = () => {
  if (getAuthorizationToken()) {
    return `Bearer ${getAuthorizationToken()}`;
  }
  return undefined;
};
